import { render, staticRenderFns } from "./Activities.vue?vue&type=template&id=4e3ed948&scoped=true&"
var script = {}
import style0 from "./Activities.vue?vue&type=style&index=0&id=4e3ed948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3ed948",
  null
  
)

export default component.exports